import { observer } from 'mobx-react-lite';

interface IProps {
    elements: (JSX.Element | null)[];
    className? : string;
}

const DynamicGridContainer = ({elements, className} : IProps) => {
  // Calcolo del numero di colonne e righe
  const number = elements.filter(x => x !== null).length;
  console.log(number)
  const numColumns = number > 3 ? Math.ceil(Math.sqrt(number)) : number > 1 ? 2 : 1; // Numero di colonne
  const numRows = Math.ceil(number / numColumns); // Numero di righe

  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(1%, ${100 / numColumns}%))`, // Dimensioni minime e massime per le colonne
    gridAutoRows: `minmax(1%,${100 / numRows}%)`, // Altezza minima e massima per le righe
  };

  return (
    <div className={className} style={{...containerStyle}}>
      {elements.map((element, index) => (
        <div key={"videoElementUpperDiv" + index}>
        {element}
        </div>
      ))}

      {/* Spazi vuoti per completare la griglia */}
      {Array(numColumns * numRows - number)
        .fill(null)
        .map((_, index) => (
          <div className="empty-cell" key={"empty-cell" + number + "_" + index} />
        ))}
    </div>
  );
};

export default observer(DynamicGridContainer);